

import React, { useState, useEffect } from 'react';
import BasicCustomTable from '../../../component/basicTable';
import { columns, rows } from '../../../constants/approvalDashboard';
import CustomPopupForm from '../../../component/customPopupModel';
import axiosInstance from '../../../configuration/request';
import { useSnackbar } from '../../../component/SnackbarContext';
import { useSelector } from 'react-redux';
import { getApprovalManagementPermissions } from '../../../utils/rolesAndPermissions';
import { capitalize } from '../../../utils/stringValidation';

const ApprovalDashboard = () => {
  const showSnackbar = useSnackbar();
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [approvalUser, setApprovalUser] = useState([]);
  const { userType } = useSelector(state => state.counter);
  const permissions = useSelector((state) => state.counter.permissions);
  const rolePermissions = permissions?.[0]?.permissions || [];
  const { canEdit } = getApprovalManagementPermissions(rolePermissions);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    fetchUsers(page, rowsPerPage)
  }, []);

  const finalColumns = React.useMemo(() => {
    if (!canEdit) {
      // remove the 'action' column
      return columns.filter((col) => col.field !== "action");
    }
    return columns;
  }, [canEdit]);

  const fetchUsers = (pageNumber = 1, limit = 10) => {
    axiosInstance
      .get(`customer/users?usertype=business-delivery&isApproved=inprocess&page=${pageNumber}&limit=${limit}`)
      .then((res) => {
        const rawUsers = res?.data?.data || [];
        const formattedUser = rawUsers.map((item) => {
          const isBusiness = item?.userType === 'business user';
          const isDelivery = item?.userType === 'delivery user';
          const firstStore = isBusiness ? (item?.stores?.[0] || {}) : {};
          const deliveryInfo = isDelivery ? (item?.deliveryPerson || {}) : {};

          return {
            user_id: item?.id ?? null,
            id: item?.id ?? null,
            name: item?.name ?? "",
            submission_date: item?.created_at?.split("T")[0] ?? null,
            approval_status: capitalize(item?.isApproved) ?? "",
            email: item?.email ?? "",
            phoneNumber: item?.phone_number ?? "",
            type: item?.userType ?? "",

            store_phone: firstStore.store_phone ?? "",
            licenceNumber: firstStore.licenceNumber ?? "",
            storeName: firstStore.storeName ?? "",

            vehicle_type: deliveryInfo.vehicle_type ?? "",
            vehicle_number: deliveryInfo.vehicle_number ?? "",

            address: isBusiness
              ? firstStore?.storeAddresses ?? []
              : item?.addresses ?? [],

            uploadedDocs: isBusiness
              ? firstStore?.uploadDoc ?? []
              : deliveryInfo?.uploadDoc ?? [],

            isDisabled: !item?.name
          };
        });

        setApprovalUser(formattedUser);
        setPage(Number(res?.data?.page) || 0);
        setTotalCount(res?.data?.total || 0);
      })
      .catch((error) => {
        showSnackbar(
          error?.response?.data?.message || "Something went wrong!",
          "error"
        );
      });
  };


  const handlePageChangeRequest = (newPage, newRowsPerPage) => {
    setPage(newPage);
    setRowsPerPage(newRowsPerPage);
    fetchUsers(newPage, newRowsPerPage);
  };

  const handleClose = () => {
    setOpen(false)
    setSelectedRow(null)
  };
  const handleView = (row) => {
    setSelectedRow(row)
    setOpen(true)

  }
  const handleSubmit = () => {
    handleClose()
    fetchUsers()
  };

  return (
    <div className="px-4">
      <h2 className="text-2xl font-semibold mb-4 mt-2 ml-3">Approval Dashboard</h2>
      <div className='px-2 pt-1 pb-4  h-[calc(100vh-150px)]'>
        <BasicCustomTable
          columns={finalColumns}
          rows={approvalUser}
          onView={handleView}
          colorHeader={true}
          customClassHeader={"table-header-cell-colored"}
          tableName='approval'
          maxHeightClass="max-h-[calc(100vh-235px)]"
          canEdit={canEdit}
          backendPagination={true}
          totalCount={totalCount}
          onPageChangeRequest={handlePageChangeRequest}
          pageLimit={rowsPerPage}
          page={page}
        />
      </div>
      <CustomPopupForm
        isOpen={open}
        handleClose={handleClose}
        dialogType={"approve-reject"}
        dialogDetails={selectedRow}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default ApprovalDashboard;
